import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import DtnService from '../../../services/DtnService';
import JobDetails from './paritals/JobDetails';
import moment from 'moment';
import { snakeCaseToTitle } from '../../../utils/Helpers';
import JobExtras from '../JobExtras';
import FormMultiSelect from '../../_shared/forms/FormMultiSelect';
import SubmitButton from '../../_shared/SubmitButton';
import DtnPhotos from './paritals/DtnPhotos';
import DriverSignature from './paritals/DriverSignature';
import WasteCleared from './paritals/WasteCleared';
import Skip from './paritals/Skip';
import PricingDetails from './paritals/PricingDetails';
import StatusButtons from './paritals/StatusButtons';
import CustomerDetails from './paritals/CustomerDetails';
import OperativeDetails from './paritals/OperativeDetails';
import RecycledWasteChart from '../recycle/RecycledWasteChart';
import CreateFollowOnButton from '../../_shared/CreateFollowOnButton';

class EditVoid extends Component {
    constructor(props) {
        super(props);

        let { job, dtn, type } = this.props;
        this.recycledWasteRef = React.createRef();
        let collectionDate = dtn.collection_date ? new Date(dtn.collection_date) : '';
        let completionTime = dtn.completion_time ? new Date(dtn.completion_time) : '';
        let jobNotes = dtn.job_notes !== 'no' ? dtn.job_notes : '';

        let tipOffOptions = [...this.props.tipOffOptions];

        let tipOff = tipOffOptions.find((tipOff) => {
            return tipOff.value === this.props.job.tip_off_id;
        });

        const hasRecycledWaste = !!this.props.hasRecycledWaste;
        const customerUsesRecycling = !!this.props.customerUsesRecycling;
        const firstOperative = this.props.driver || {};
        this.state = {
            address: job.address_line_1 || '',
            postcode: job.postcode || '',
            collection_date: collectionDate || '',
            completion_time: completionTime || '',
            job_notes: jobNotes,
            clearing_inside: type.clearing_inside || '',
            clearing_garden: type.clearing_garden || '',
            time: type.time || '',
            total_waste_removed: type.total_waste_removed || 0,
            estimate_waste_removed: type.estimate_waste_removed || '',
            gardening: type.gardening || '',
            gardening_note: type.gardening_note || '',
            extrasOptions: this.props.jobExtras || '',
            additionalCosts: this.props.additionalCosts || '',
            gardeningExtrasOptions: this.props.gardeningExtras || '',
            sorCodesOptions: this.props.sorCodesOptions || [],
            sorExtrasOptions: this.props.sorExtrasOptions || [],
            selectedExtras: job.job_extras || '',
            selectedGardeningExtras: job.gardening_extras || '',
            selectedSorCodes: dtn.sor_codes
                ? dtn.sor_codes.map((s) => {
                      const code = this.props.sorCodesOptions.find((c) => c.id === s.id);
                      if (code) {
                          code.quantity = s.quantity;
                          code.provider_quantity = s.provider_quantity;
                          return code;
                      }
                      return s;
                  })
                : [],
            selectedSorExtras: dtn.sor_extras || [],
            skips: dtn.skips || [],
            jobTypePrice: 0,
            providerJobTypePrice: 0,
            totalWasteRemovedPrice: 0,
            providerTotalWasteRemovedPrice: 0,
            totalPrice: 0,
            providerTotalPrice: 0,
            provider_total_waste_removed: type.provider_total_waste_removed || 0,
            recycledWaste: [],
            images_before: '',
            images_after: '',
            van_images_before: '',
            van_images_after: '',
            customer_signature: '',
            rejected_files: {},
            errors: {},
            job_extras: {},
            gardening_extras: {},
            loading: false,
            tipOff: typeof tipOff !== 'undefined' ? tipOff : [],
            hasRecycledWaste,
            customerUsesRecycling,
            recycledWasteValid: hasRecycledWaste,
            recycledWasteSaved: hasRecycledWaste,
            savingRecycledWaste: false,
            provider_quantity: job.provider_quantity || 0,
            quantity: job.quantity || 0,
            admin_notes: job.admin_notes || '',
            purchase_order_number: job.purchase_order_number || '',
            sla: job.sla || '',
            price_quoted: job.price_quoted === 1 ? 'yes' : 'no',
            custom_price: job.custom_price || 0,
            custom_price_with_vat: job.custom_price ? job.custom_price * 1.2 : 0,
            disable_status_buttons: false,
            provider_price_quoted: job.provider_price_quoted === 1 ? 'yes' : 'no',
            provider_custom_price: job.provider_custom_price || '',
            provider_custom_price_with_vat: job.provider_custom_price ? job.provider_custom_price * 1.2 : '',
            route_started: '',
            route_arrived: '',
            first_operative: firstOperative,
            job_completed: '',
            manager_review: job.manager_review === 1 ? 'yes' : 'no',
            voidJobNotes: job.void_job_notes || {},
            manager_review_reason: job.manager_review_reason || '',
            managerReview: null,
        };
        this.dtnService = new DtnService();
    }

    componentDidMount() {
        let jobTypePrice = this.setJobTypePrice();
        let providerJobTypePrice = this.setProviderJobTypePrice();
        this.calculateTotalPrice(jobTypePrice, providerJobTypePrice);

        this.dtnService.requiresSuperadminReview(this.props.job.id).then(({ data }) => {
            this.setState({
                managerReview: data.managerReview || null,
            });
        });

        if (this.state.customerUsesRecycling && this.state.hasRecycledWaste) {
            this.setState({
                recycledWasteValid: true,
                recycledWasteSaved: true,
                savingRecycledWaste: false,
            });
        }
    }

    jobNotTippedModal = () => {
        window.swal.fire({
            title: `Waste not tipped`,
            text: ``,
            type: 'info',
            confirmButtonText: `Ok`,
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedSorCodes.length !== this.state.selectedSorCodes.length) {
            this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
        }
    }

    handleChange = (e) => {
        let { name, value, type } = e.target;
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (type === 'checkbox') {
            value = this.state[name] === 'yes' ? 'no' : 'yes';
        }

        this.setState(
            {
                [name]: value,
                errors: errorsObject,
            },
            () => {
                if (name === 'provider_quantity' || name === 'quantity') {
                    this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
                }
            }
        );
    };

    handleProviderCustomPriceChange = (e) => {
        const { name, value } = e.target;
        const numericValue = parseFloat(value) || 0;
        if (name === 'provider_custom_price') {
            this.setState({
                provider_custom_price: numericValue,
                provider_custom_price_with_vat: +(numericValue * 1.2).toFixed(2),
            });
        } else {
            this.setState({
                provider_custom_price_with_vat: numericValue,
                provider_custom_price: +(numericValue / 1.2).toFixed(2),
            });
        }
    };

    handleTotalWasteChange = (e) => {
        let { name, value, type } = e.target;
        let errorObject = { ...this.state.errors };
        delete errorObject[name];

        this.setState(
            {
                [name]: value,
            },
            () => {
                this.calculateWasteRemovedPrice();
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
            }
        );
    };

    handleDisabled = (name) => {
        return name === 'clearing_inside' || name === 'clearing_garage';
    };

    handleDateChange = (date, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];
        this.setState({ [name]: date, errors: errorsObject });
    };

    setJobTypePrice = () => {
        let jobType = this.props.jobTypes.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });

        let jobTypePrice = jobType.pivot.price;

        this.setState({
            jobTypePrice: jobTypePrice,
        });

        return jobTypePrice;
    };

    setProviderJobTypePrice = () => {
        let providerJobType = this.props.serviceProvider.job_types.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });
        let providerJobTypePrice;

        if (typeof providerJobType !== 'undefined') {
            providerJobTypePrice = providerJobType.pivot ? providerJobType.pivot.price : providerJobType.default_price;
        } else {
            providerJobType = this.props.jobTypes.find((jobType) => {
                return jobType.id === this.props.job.job_type_id;
            });
            providerJobTypePrice = providerJobType.provider_default_price || 0;
        }

        this.setState({
            providerJobTypePrice: providerJobTypePrice,
        });

        return providerJobTypePrice;
    };

    calculateWasteRemovedPrice = () => {
        if (this.props.job.customer.uses_skip) {
            return 0;
        }

        let providerWastePrice = this.state.provider_total_waste_removed * 3051;
        let wastePrice = this.state.total_waste_removed * 3051;

        this.setState({
            totalWasteRemovedPrice: wastePrice,
            providerTotalWasteRemovedPrice: providerWastePrice,
        });

        return wastePrice;
    };

    calculateTotalPrice = (jobTypePrice, providerJobTypePrice) => {
        let totalPrice = jobTypePrice * this.state.quantity;
        let providerTotalPrice = providerJobTypePrice * (this.state.provider_quantity || 0);

        let totalWasteRemovedPrice = 0;
        let providerTotalWasteRemovedPrice = 0;
        if (!this.props.job.customer.uses_skip) {
            totalWasteRemovedPrice = this.state.total_waste_removed * 3051;
            providerTotalWasteRemovedPrice = this.state.provider_total_waste_removed * 3051;
        }

        if (this.state.selectedSorCodes) {
            this.state.selectedSorCodes.map((extra) => {
                totalPrice += extra.price * (extra.quantity ? extra.quantity : 1);
                providerTotalPrice += extra.providerPrice * (extra.provider_quantity ? extra.provider_quantity : 0);
            });
        }

        if (this.state.selectedSorExtras) {
            this.state.selectedSorExtras.map((extra) => {
                totalPrice += extra.price * (extra.quantity ? extra.quantity : 1);
                providerTotalPrice += extra.providerPrice * (extra.quantity ? extra.quantity : 0);
            });
        }

        if (this.state.skips.length) {
            this.state.skips.map((skip) => {
                totalPrice += skip.price * (skip.quantity ? skip.quantity : 1);
                providerTotalPrice += skip.providerPrice * (skip.provider_quantity ? skip.provider_quantity : 0);
            });
        } else {
            totalPrice += totalWasteRemovedPrice;
            providerTotalPrice += providerTotalWasteRemovedPrice;
        }

        this.setState({
            totalPrice,
            providerTotalPrice,
            totalWasteRemovedPrice: totalWasteRemovedPrice,
            providerTotalWasteRemovedPrice: providerTotalWasteRemovedPrice,
        });
    };

    syncSorExtras = (type) => {
        if (type === 'selectedSorCodes' || type === 'selectedSorExtras' || type === 'skips') {
            return;
        }
        let sorCodesOptions = [...this.props.sorCodesOptions];
        let jobExtras = this.state.selectedExtras;
        let gardeningExtras = this.state.selectedGardeningExtras;

        let manuallyAddedCodes = this.state.selectedSorCodes.filter(
            (selectedSorCode) => !selectedSorCode.automaticallyAdded
        );
        sorCodesOptions.forEach((sorCode) => (sorCode.automaticallyAdded = false));

        let extrasSorCodes = jobExtras.reduce((results, extra) => {
            let sorCode = sorCodesOptions.find((sorCode, index) => {
                if (sorCode.extraable_type === 'App\\Models\\JobExtras' && sorCode.extraable_id === extra.value) {
                    sorCodesOptions.splice(index, 1);

                    if (sorCode.provider_quantity <= 1) {
                        sorCode.provider_quantity = sorCode.quantity;
                    }

                    sorCode.automaticallyAdded = true;
                    return sorCode;
                }
            });

            if (typeof sorCode !== 'undefined') {
                results.push(sorCode);
            }

            return results;
        }, []);

        let gardeningSorCodes = gardeningExtras.reduce((results, extra) => {
            let sorCode = sorCodesOptions.find((sorCode, index) => {
                if (sorCode.extraable_type === 'App\\Models\\GardeningExtras' && sorCode.extraable_id === extra.value) {
                    sorCodesOptions.splice(index, 1);

                    if (sorCode.provider_quantity <= 1) {
                        sorCode.provider_quantity = sorCode.quantity;
                    }

                    sorCode.automaticallyAdded = true;
                    return sorCode;
                }
            });

            if (typeof sorCode !== 'undefined') {
                results.push(sorCode);
            }

            return results;
        }, []);

        let sorCodes = extrasSorCodes.concat(gardeningSorCodes);

        this.state.selectedSorCodes.forEach((selectedSorCode) => {
            const sorCode = sorCodes.find((s) => s.id === selectedSorCode.id);
            if (!sorCode) {
                // replace any manually added codes
                let newCode = this.state.sorCodesOptions.find((s) => s.id === selectedSorCode.id);
                if (newCode && manuallyAddedCodes.find((m) => m.id === selectedSorCode.id)) sorCodes.push(newCode);
            }
        });

        this.setState({
            selectedSorCodes: sorCodes,
        });
    };

    syncSorCodeExtraQty = (type, extra) => {
        let sorCodes = [...this.state.selectedSorCodes];

        if (type !== 'selectedExtras' && type !== 'selectedGardeningExtras') {
            return sorCodes;
        }

        let sorModelType = type === 'selectedExtras' ? 'App\\Models\\JobExtras' : 'App\\Models\\GardeningExtras';
        let sorIndex;

        sorIndex = this.state.selectedSorCodes.findIndex((sorCode) => {
            return sorCode.extraable_id === extra.value && sorCode.extraable_type === sorModelType;
        });

        if (sorIndex !== -1) {
            let sorCode = sorCodes[sorIndex];
            sorCode.quantity = extra.quantity;
            sorCode.provider_quantity = extra.provider_quantity;
        }

        return sorCodes;
    };

    handleMultiSelectChange = (value, type) => {
        let extras = [];
        if (value !== null && typeof value !== 'undefined' && value.length > 0) {
            extras = [...value];

            if (!extras[extras.length - 1].hasOwnProperty('quantity')) {
                extras[extras.length - 1].quantity = 1;
            }

            if (
                !extras[extras.length - 1].hasOwnProperty('provider_quantity') ||
                extras[extras.length - 1].provider_quantity === ''
            ) {
                extras[extras.length - 1].provider_quantity = 1;
            }
        }
        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.syncSorExtras(type);
                // this.syncExtrasSor(type);
                if (type === 'selectedSorCodes' || type === 'selectedSorExtras' || type === 'skips') {
                    this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
                }
            }
        );
    };

    handleExtraQtyChange = (e, extra, type) => {
        let extras = [...this.state[type]];

        let extraIndex = extras.findIndex((ex) => ex.value === extra.value);

        extras[extraIndex][e.target.name] = e.target.value;

        if (e.target.name === 'quantity') {
            extras[extraIndex]['provider_quantity'] = e.target.value;
        }

        if (extra.singular) {
            extras[extraIndex][e.target.name] = e.target.value;
        }

        let sorCodes = this.syncSorCodeExtraQty(type, extras[extraIndex]);

        this.setState(
            {
                [type]: extras,
                selectedSorCodes: sorCodes,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice, this.state.providerJobTypePrice);
            }
        );
    };

    handleCustomPriceChange = (e) => {
        let { name, value } = e.target;

        const numericValue = Number(value); // key fix

        let custom_price, custom_price_with_vat;

        if (name === 'custom_price') {
            custom_price = numericValue;
            custom_price_with_vat = +(numericValue * 1.2).toFixed(2);
        } else {
            custom_price_with_vat = numericValue;
            custom_price = +(numericValue / 1.2).toFixed(2);
        }

        this.setState({
            custom_price,
            custom_price_with_vat,
        });
    };

    onDrop = (acceptedFiles, name) => {
        let oldFiles = [...this.state[name]];
        let files = oldFiles.concat(acceptedFiles);

        this.setState({
            [name]: files,
        });
    };

    removeFile = (file, index, name) => {
        let acceptedFiles = [...this.state[name]];
        acceptedFiles.splice(index, 1);
        this.setState({
            [name]: acceptedFiles,
        });
    };

    onDropReject = (rejectedFiles, name) => {
        this.setState({
            rejectedFiles: { [name]: 'Photo size should be less than 2mb' },
        });
    };

    handleSearchableSelectChange = (e, name) => {
        if (name == 'tip_offs') {
            name = 'tipOff';
        }
        this.setState({
            [name]: e,
        });
    };

    removeExistingMedia = (imageId) => {
        window.swal
            .fire({
                title: `Delete photo?`,
                text: `Are you sure you want to delete photo??`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: `Delete`,
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    url: `/jobs/${this.props.job.id}/dtn/media/${imageId}`,
                    dataType: 'json',
                    type: 'delete',
                    success: () => {
                        location.reload();
                    },
                });
            });
    };

    mapInputsToFormData = () => {
        let formData = new FormData();
        const mappable = [
            'address',
            'postcode',
            'collection_date',
            'completion_time',
            'job_notes',
            'total_waste_removed',
            'provider_total_waste_removed',
            'estimate_waste_removed',
            'gardening_note',
            'provider_quantity',
            'quantity',
            'admin_notes',
            'sla',
            'purchase_order_number',
            'custom_price',
            'price_quoted',
            'provider_price_quoted',
            'provider_custom_price',
        ];

        if (!this.props.dtn.id) {
            //mappable.push('route_started');
            //mappable.push('route_arrived');
            //mappable.push('job_completed');
        }

        this.state.images_before
            ? this.state.images_before.forEach((image) => formData.append('images_before[]', image))
            : '';
        this.state.images_after
            ? this.state.images_after.forEach((image) => formData.append('images_after[]', image))
            : '';
        this.state.van_images_before
            ? this.state.van_images_before.forEach((image) => formData.append('van_images_before[]', image))
            : '';
        this.state.van_images_after
            ? this.state.van_images_after.forEach((image) => formData.append('van_images_after[]', image))
            : '';
        this.state.customer_signature ? formData.append('customer_signature', this.state.customer_signature[0]) : '';
        formData.append('job_extras', JSON.stringify(this.state.selectedExtras));
        formData.append('gardening_extras', JSON.stringify(this.state.selectedGardeningExtras));
        formData.append('skips', JSON.stringify(this.state.skips));
        formData.append('sor_codes', JSON.stringify(this.state.selectedSorCodes));
        formData.append('sor_extras', JSON.stringify(this.state.selectedSorExtras));
        formData.append('tip_off_id', this.state.tipOff.value || '');
        formData.append('first_operative', this.state.first_operative?.value || this.state.first_operative?.id || '');
        formData.append('manager_review', this.state.manager_review === 'yes' ? 1 : 0);
        formData.append('manager_review_reason', this.state.manager_review_reason);
        mappable.forEach((input) => {
            if (
                input === 'collection_date' ||
                input === 'completion_time' ||
                input === 'route_started' ||
                input === 'route_arrived' ||
                input === 'job_completed'
            ) {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('YYYY/MM/DD HH:mm') : '');
                return;
            }
            formData.append(input, this.state[input]);
        });

        return formData;
    };

    onSubmit = async (e) => {
        e.preventDefault();

        this.setState({ errors: {} });

        const success = await this.saveDtn(true);
        if (!success) {
            toastr.error('Please complete required fields before continuing.');
        }
    };
    saveDtn = async (shouldReload = true) => {
        try {
            if (!this.validateForm()) {
                const errors = this.getValidationErrors();

                toastr.error(Object.values(errors).join('<br />'), 'Please complete required fields', {
                    allowHtml: true,
                });

                return false;
            }

            if (this.recycledWasteRef.current) {
                this.setState({ savingRecycledWaste: true });

                try {
                    const saved = await this.recycledWasteRef.current.save();
                    this.setState({ recycledWasteSaved: saved });

                    if (!saved) {
                        return false;
                    }
                } catch (err) {
                    console.error('Error saving recycled waste', err);
                    return false;
                } finally {
                    this.setState({ savingRecycledWaste: false });
                }
            }

            if (this.props.dtn.id) {
                return await this.onSubmitValidateUpdate(shouldReload);
            }

            return await this.onSubmitValidateStore(shouldReload);
        } catch (e) {
            return false;
        }
    };

    onSubmitValidateStore = async (shouldReload = true) => {
        if (!this.validateForm()) return false;

        this.setState({ loading: true });

        const formData = this.mapInputsToFormData();

        try {
            const res = await this.dtnService.storeDtn(this.props.job.id, formData);
            this.setState({ loading: false });
            toastr.success('Wtn was successfully saved');
            if (shouldReload) location = this.props.editRoute;
            return true;
        } catch (err) {
            this.setState({ loading: false });
            toastr.error('There was a problem while submitting the form. Please try again.');
            throw err;
        }
    };

    onSubmitValidateUpdate = async (shouldReload = true) => {
        if (!this.validateForm()) return false;

        this.setState({ loading: true });

        const formData = this.mapInputsToFormData();
        formData.append('_method', 'PATCH');

        try {
            const res = await this.dtnService.updateDtn(this.props.job.id, formData);
            this.setState({ loading: false });
            toastr.success('Wtn was successfully edited');
            if (shouldReload) window.location.reload();
            return true;
        } catch (err) {
            this.setState({ loading: false });
            toastr.error('There was a problem while submitting the form. Please try again.');
            throw err;
        }
    };

    getValidationErrors = () => {
        let errors = {};

        const fields = [
            'address',
            'postcode',
            'collection_date',
            'completion_time',
            'total_waste_removed',
            'estimate_waste_removed',
        ];

        if (this.state.price_quoted === 'yes') {
            fields.push('custom_price');
        }

        if (this.state.provider_price_quoted === 'yes') {
            fields.push('provider_custom_price');
        }

        fields.map((field) => {
            const value = this.state[field];

            if (value === '' || value === null || value === undefined) {
                errors[field] = `${snakeCaseToTitle(field)} field is required`;
            }
        });

        if (!this.state.first_operative || (!this.state.first_operative.value && !this.state.first_operative.id)) {
            errors.first_operative = 'First operative is required';
        }

        if (!this.state.tipOff || !this.state.tipOff.value) {
            errors.tipOff = 'Select tip off field is required';
        }

        if (this.props.job.customer.uses_skip && (!this.state.skips || this.state.skips.length === 0)) {
            errors.skips = 'Waste Volume Removed field is required';
        }

        return errors;
    };

    validateForm = () => {
        const errors = this.getValidationErrors();
        this.setState({ errors });

        return Object.keys(errors).length === 0;
    };

    disableStatusButtons = () => {
        this.setState({
            disable_status_buttons: true,
        });
    };

    render() {
        const recycledWasteLocked =
            this.state.customerUsesRecycling &&
            (!this.state.hasRecycledWaste || !this.state.recycledWasteValid || this.state.savingRecycledWaste);

        const isManagerUser = ['manager', 'admin', 'superadmin'].includes(this.props.currentUser?.role?.name);

        const showPendingManagerReview =
            isManagerUser &&
            this.props.job.status === 'done' &&
            this.state.managerReview &&
            this.state.managerReview.type === 'manager' &&
            Number(this.state.managerReview.approved) === 0;

        const showManagerReviewComments =
            this.props.currentUser?.role?.name === 'superadmin' && this.state.managerReview;
        
        return (
            <Fragment>
                <form onSubmit={this.onSubmit} encType="multipart/form-data" className="transform-text">
                    <CustomerDetails
                        customer={this.props.job.customer.name}
                        customer_contact={this.props.job.contact.first_name + ' ' + this.props.job.contact.last_name}
                        job_source={this.props.job_source ? this.props.job_source.job_source : ''}
                        purchase_order_number={this.state.purchase_order_number}
                        sla={this.state.sla}
                        department={this.props.job.contact ? this.props.job.contact.department.name : ''}
                        handleChange={this.handleChange}
                    />

                    <JobDetails
                        address={this.state.address}
                        postcode={this.state.postcode}
                        collection_date={this.state.collection_date}
                        completion_time={this.state.completion_time}
                        errors={this.state.errors}
                        handleChange={this.handleChange}
                        handleDateChange={this.handleDateChange}
                        tipOff={this.state.tipOff}
                        tipOffOptions={this.props.tipOffOptions}
                        handleSearchableSelectChange={this.handleSearchableSelectChange}
                        provider_quantity={this.state.provider_quantity}
                        quantity={this.state.quantity}
                        manager_review={this.state.manager_review}
                        manager_review_reason={this.state.manager_review_reason}
                        manager_review_flag_reason={this.props.job.manager_review_flag_reason}
                    />

                    <OperativeDetails
                        first_operative={this.state.first_operative}
                        second_operative={this.state.second_operative}
                        second_member_id={this.state.second_member_id}
                        route_started={this.state.route_started}
                        route_arrived={this.state.route_arrived}
                        job_completed={this.state.job_completed}
                        errors={this.state.errors}
                        operatives={this.props.operatives}
                        handleDateChange={this.handleDateChange}
                        handleChange={this.handleChange}
                        handleSearchableSelectChange={this.handleSearchableSelectChange}
                    />

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Job notes</h6>
                        </div>
                    </div>

                    {this.props.previousFollowOnDescription ? (
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Previous job notes</label>
                                <textarea
                                    name="previous_job_notes"
                                    id="previous_job_notes"
                                    className="form-control"
                                    value={this.props.previousFollowOnDescription}
                                    rows={5}
                                    disabled
                                >
                                    {this.props.previousFollowOnDescription}
                                </textarea>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Admin notes</label>
                            <textarea
                                name="admin_notes"
                                id="admin_notes"
                                rows={5}
                                value={this.state.admin_notes}
                                onChange={this.handleChange}
                                placeholder="Admin note"
                                className="form-control"
                            >
                                {this.state.admin_notes}
                            </textarea>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Job notes</label>
                            <textarea
                                className="form-control"
                                name="job_notes"
                                id="job_notes"
                                value={this.state.job_notes || ''}
                                onChange={this.handleChange}
                                placeholder="Job note"
                                rows="5"
                            >
                                {this.state.job_notes}
                            </textarea>
                        </div>
                    </div>

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Waste cleared</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Cleaning notes</label>
                            <textarea
                                className="form-control"
                                value={
                                    `Residential cleaned: ${this.state.voidJobNotes?.residentialCleaned || ''}\n` +
                                    `Residential reason: ${this.state.voidJobNotes?.residentialReason || ''}\n` +
                                    `Has communal area: ${this.state.voidJobNotes?.hasCommunalArea || ''}\n` +
                                    `Communal cleaned: ${this.state.voidJobNotes?.communalCleaned || ''}\n` +
                                    `Communal reason: ${this.state.voidJobNotes?.communalReason || ''}`
                                }
                                readOnly
                                rows="6"
                            ></textarea>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Operative notes</label>
                            <textarea
                                className="form-control"
                                name="gardening_note"
                                id="gardeningNote"
                                value={this.state.gardening_note || ''}
                                onChange={this.handleChange}
                                placeholder="Operative note"
                                rows="5"
                            ></textarea>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormMultiSelect
                                label="Sor codes"
                                options={this.state.sorCodesOptions}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selectedSorCodes')
                                }
                                onExtraQtyChange={this.handleExtraQtyChange}
                                classes="form-control"
                                prefixes={this.state.selectedSorCodes}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormMultiSelect
                                label="Additional Sor extras"
                                options={this.state.sorExtrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selectedSorExtras')
                                }
                                onExtraQtyChange={this.handleExtraQtyChange}
                                classes="form-control"
                                prefixes={this.state.selectedSorExtras}
                            />
                        </div>
                    </div>

                    {this.props.job.customer.uses_skip ? (
                        <Skip
                            skipOptions={this.props.skipOptions}
                            handleMultiSelectChange={this.handleMultiSelectChange}
                            onExtraQtyChange={this.handleExtraQtyChange}
                            classes="form-control"
                            skips={this.state.skips}
                            errors={this.state.errors}
                            dtn={true}
                            serviceProvider={this.props.serviceProvider}
                        />
                    ) : (
                        ''
                    )}
                    <WasteCleared
                        total_waste_removed={this.state.total_waste_removed}
                        provider_total_waste_removed={this.state.provider_total_waste_removed}
                        estimate_waste_removed={this.state.estimate_waste_removed}
                        errors={this.state.errors}
                        handleChange={this.handleChange}
                        handleTotalWasteChange={this.handleTotalWasteChange}
                        totalWasteRemovedPrice={this.state.totalWasteRemovedPrice}
                        providerTotalWasteRemovedPrice={this.state.providerTotalWasteRemovedPrice}
                    />

                    <JobExtras
                        extras={this.state.selectedSorCodes}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType={'selectedSorCodes'}
                        extrasPrices={this.props.sorCodesOptions}
                        dtn={true}
                        serviceProvider={this.props.serviceProvider}
                        providerExtrasType={'sor_codes'}
                    />
                    <JobExtras
                        extras={this.state.selectedSorExtras}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType={'selectedSorExtras'}
                        extrasPrices={this.props.sorExtrasOptions}
                        dtn={true}
                        serviceProvider={this.props.serviceProvider}
                        providerExtrasType={'sor_extras'}
                    />

                    <JobExtras
                        extras={this.state.skips}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType={'skips'}
                        extrasPrices={this.props.skipOptions}
                        dtn={true}
                        serviceProvider={this.props.serviceProvider}
                        providerExtrasType={'sor_codes'}
                    />

                    <PricingDetails
                        sorCodes={this.state.selectedSorCodes}
                        extras={this.state.skips}
                        skips={this.state.selectedSorExtras}
                        totalPrice={this.state.totalPrice}
                        timeSpentWorking={this.props.timeSpentWorking}
                        laborCost={this.props.laborCost}
                        wasteCollectedPrice={this.state.wasteCollectedPrice}
                        providerTotalPrice={this.state.providerTotalPrice}
                        price_quoted={this.state.price_quoted}
                        custom_price={this.state.custom_price}
                        custom_price_with_vat={this.state.custom_price_with_vat}
                        provider_price_quoted={this.state.provider_price_quoted}
                        provider_custom_price={this.state.provider_custom_price}
                        provider_custom_price_with_vat={this.state.provider_custom_price_with_vat}
                        handleProviderCustomPriceChange={this.handleProviderCustomPriceChange}
                        handleChange={this.handleChange}
                        handleCustomPriceChange={this.handleCustomPriceChange}
                        additionalCosts={this.state.additionalCosts}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Photos before clearing"
                        name="images_before"
                        acceptedFiles={this.state.images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Photos after clearing"
                        name="images_after"
                        acceptedFiles={this.state.images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos before clearing"
                        name="van_images_before"
                        acceptedFiles={this.state.van_images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos after clearing"
                        name="van_images_after"
                        acceptedFiles={this.state.van_images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DriverSignature imagePath={this.props.signaturePath} driver={this.props.driver} />

                    <DtnPhotos
                        title="Customer signature"
                        name="customer_signature"
                        acceptedFiles={this.state.customer_signature}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.customer_signature}
                        multiple={false}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    {this.state.customerUsesRecycling && this.props.dtn?.id && (
                        <div className="row">
                            <div className="col-md-12">
                                <RecycledWasteChart
                                    ref={this.recycledWasteRef}
                                    jobId={this.props.job.id}
                                    onValidityChange={(isValid) => {
                                        if (this.state.recycledWasteValid !== isValid) {
                                            this.setState({
                                                recycledWasteValid: isValid,
                                            });
                                        }
                                    }}
                                    onSaveStart={() => {
                                        this.setState({ savingRecycledWaste: true });
                                    }}
                                    onSaved={() => {
                                        this.setState({
                                            savingRecycledWaste: false,
                                            hasRecycledWaste: true,
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    {this.state.customerUsesRecycling &&
                        this.props.dtn?.id &&
                        this.state.hasRecycledWaste === false && (
                            <div className="alert alert-warning mt-3">
                                ⚠️ This job does not have any recycled waste recorded! This job cannot be completed unti
                                waste is recorded.
                            </div>
                        )}

                    {showPendingManagerReview && (
                        <div className="row">
                            <div className="col-12">
                                <div className="alert alert-warning mt-3">
                                    <strong>Pending manager review</strong>

                                    <div className="mt-2">
                                        Review Reason:{' '}
                                        {this.state.managerReview?.reason ||
                                            this.props.job.manager_review_flag_reason ||
                                            '—'}
                                    </div>

                                    <small>
                                        Service provider: {this.props.serviceProvider?.name || '—'}
                                        <br />
                                        Requested by: {this.state.managerReview?.requested_by || '—'}
                                    </small>
                                </div>
                            </div>
                        </div>
                    )}

                    {showManagerReviewComments && (
                        <div className="row">
                            <div className="col-12">
                                <div className="alert alert-info mt-3">
                                    <strong>Manager review comments:</strong>

                                    <div className="mt-2">{this.state.managerReview?.outcome || '—'}</div>

                                    <hr />

                                    <small>
                                        Service provider: {this.props.serviceProvider?.name || '—'}
                                        <br />
                                        Requested by: {this.state.managerReview?.requested_by || '—'}
                                        <br />
                                        Created by: {this.state.managerReview?.created_by || '—'}
                                        <br />
                                        Approved by: {this.state.managerReview?.approved_by || '—'}
                                        <br />
                                        Approved at: {this.state.managerReview?.approved_at || '—'}
                                    </small>
                                </div>
                            </div>
                        </div>
                    )}

                    <SubmitButton
                        buttonText={this.props.dtn.id ? 'Edit WTN' : 'Create WTN'}
                        loading={this.state.loading}
                        style={{ width: 200, marginTop: 20 }}
                    />

                    <a
                        href={this.props.downloadUrl}
                        className="btn btn-cw-green"
                        style={{ width: 200, marginTop: 20, marginLeft: 15 }}
                    >
                        Download WTN
                    </a>

                    {this.props.job.status === 'done' && (
                        <StatusButtons
                            job={this.props.job}
                            jobId={this.props.job.id}
                            style={{ marginTop: 50 }}
                            disabled={this.state.disable_status_buttons || recycledWasteLocked}
                            disableStatusButtons={this.disableStatusButtons}
                            saveDtn={this.saveDtn}
                            user={this.props.currentUser}
                        />
                    )}

                    <CreateFollowOnButton
                        job={this.props.job}
                        nextFollowOnPageRoute={this.props.nextFollowOnPageRoute}
                    />  
                </form>

                <div className="row">
                    <div className="col-md-6 text-left">
                        {this.props.previousJob ? <a href={this.props.previousJob}>Review previous job</a> : ''}
                    </div>
                    <div className="col-md-6 text-right">
                        {this.props.nextJob ? <a href={this.props.nextJob}>Review next job</a> : ''}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 text-left">
                        {this.props.previousFollowOnRoute ? (
                            <a href={this.props.previousFollowOnRoute}>Previous follow-on job</a>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className="col-md-6 text-right">
                        {this.props.nextFollowOnRoute ? (
                            <a href={this.props.nextFollowOnRoute}>Next follow-on job</a>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default EditVoid;

if (document.getElementById('edit-void')) {
    let element = document.getElementById('edit-void');
    ReactDOM.render(
        <EditVoid
            job={JSON.parse(element.dataset.job)}
            dtn={JSON.parse(element.dataset.dtn)}
            type={JSON.parse(element.dataset.type)}
            jobExtras={JSON.parse(element.dataset.job_extras)}
            additionalCosts={JSON.parse(element.dataset.additional_costs)}
            gardeningExtras={JSON.parse(element.dataset.gardening_extras)}
            media={JSON.parse(element.dataset.media)}
            signaturePath={element.dataset.signature_path}
            skipOptions={JSON.parse(element.dataset.skip)}
            sorCodesOptions={JSON.parse(element.dataset.sor_codes)}
            sorExtrasOptions={JSON.parse(element.dataset.sor_extras)}
            jobTypes={JSON.parse(element.dataset.job_types)}
            timeSpentWorking={element.dataset.time_spent_working}
            laborCost={element.dataset.labor_cost}
            tipOffOptions={JSON.parse(element.dataset.tip_off_options)}
            downloadUrl={element.dataset.download_url}
            serviceProvider={JSON.parse(element.dataset.service_provider)}
            driver={element.dataset.driver !== null ? JSON.parse(element.dataset.driver) : null}
            completeAndFollowOnRoute={element.dataset.status_and_follow_on_route}
            previousFollowOnDescription={element.dataset.previous_follow_on_description}
            previousFollowOnRoute={element.dataset.previous_follow_on_route}
            nextFollowOnRoute={element.dataset.next_follow_on_route}
            nextFollowOnPageRoute={element.dataset.next_follow_on_page_route}
            operatives={element.dataset.operatives ? JSON.parse(element.dataset.operatives) : []}
            editRoute={element.dataset.edit_route}
            hasRecycledWaste={element.dataset.hasRecycledWaste ? JSON.parse(element.dataset.hasRecycledWaste) : false}
            currentUser={JSON.parse(element.dataset.currentUser)}
            customerUsesRecycling={
                element.dataset.customerUsesRecycling ? JSON.parse(element.dataset.customerUsesRecycling) : false
            }
        />,
        element
    );
}
